import axiosInstance from './axios'
import type { AppConfig } from '@/stores/settings'
import type { GeofenceConfig } from '@/stores/settings'

/**
 * Fetch app configuration from server
 * @throws Error if fetch fails
 */
export async function fetchConfig(): Promise<AppConfig> {
    try {
        const response = await axiosInstance.get<AppConfig>('/api/warden/config')
        return response.data
    } catch (error) {
        console.error('[ConfigService] Failed to fetch config from API', error)
        throw error
    }
}

/**
 * Update geofence configuration on server
 */
export async function updateGeofenceOnServer(geofence: GeofenceConfig): Promise<void> {
    await axiosInstance.post('/api/config/geofence', geofence)
}
